'use client';

import styled from 'styled-components';

export const Header = styled.h1`
  font-size: ${({ theme }) => theme.typography.heading1.fontSize};
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  font-weight: ${(props) => props.theme.typography.heading1.fontWeight};
  line-height: ${(props) => props.theme.typography.heading1.lineHeight};
`;
